import { render, staticRenderFns } from "./CalendarioProgramacaoRegiao.vue?vue&type=template&id=667522e7"
import script from "./CalendarioProgramacaoRegiao.vue?vue&type=script&lang=js"
export * from "./CalendarioProgramacaoRegiao.vue?vue&type=script&lang=js"
import style0 from "./CalendarioProgramacaoRegiao.vue?vue&type=style&index=0&id=667522e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports